export default "__VITE_ASSET__Bkzh9R8O__"